/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Name/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Name({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Insurance/AssignedInsurance/Content/AssignedInsuranceItem/InsuredTreatments/Content/InsuredTreatment/Content/InsuredTreatmentItem/Payer/Name"
  
}) {
let txInsuredInsuranceSubscriptionPersonValueData = fromData.useDataFormat({ viewPath,
context: 'tx',
path: 'insured.insurance_subscription.person',
format: fromFormat.personName,
})
  return (<React.Fragment
>
<div
  data-testid="Name.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="tx.insured.insurance_subscription.person"
 format="/Data/format.js personName"
 text={txInsuredInsuranceSubscriptionPersonValueData}
/>
</div>
{children}
</React.Fragment>)
}